export class EditTimesheet {
    public selectedstartDate: string;
    public empno: number;
    constructor(d: any = {}) {
        this.selectedstartDate = d.selectedstartDate || '';
        this.empno = d.empno || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-timesheet/edit-timesheet.ts